const _excluded = ["claimGroup"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { useEffect, useState } from 'react';
import { Col, Row, Breadcrumb, OverlayTrigger, Popover, Button, Form } from 'react-bootstrap';
import { Link, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import CurrentClaimYear from '@rd-web-markets/shared/dist/dashboards/charts/CurrentClaimYear';
import BusinessUnitCompletionTable from '@rd-web-markets/shared/dist/dashboards/components/BusinessUnitCompletionTable';
import BusinessProjectStatePieChart from '@rd-web-markets/shared/dist/dashboards/charts/BusinessUnitProjectStatePieChart';
import TotalQEAndIntensity from '@rd-web-markets/shared/dist/dashboards/charts/TotalQEAndIntensity';
import RnDIntensity from '@rd-web-markets/shared/dist/dashboards/charts/RnDIntensity';
import SecureRamainingForecastQE from '@rd-web-markets/shared/dist/dashboards/charts/SecureRamainingForecastQE';
import BusinessUnitSelector from '@rd-web-markets/shared/dist/dashboards/components/BusinessUnitSelector';
import SubsidiaryCompanySelector from '@rd-web-markets/shared/dist/dashboards/components/SubsidiaryCompanySelector';
import regularDashboardService from '@rd-web-markets/shared/dist/services/regular_dashboard.service';
import BreadcrumbsPortal from '@rd-web-markets/shared/dist/util/BreadcrumbsPortal';
import { Loader } from '@rd-web-markets/shared/dist/util/Loader';
import useRecentVisits from '@rd-web-markets/shared/dist/hooks/useRecentVisits';
import SubsidiaryCompanyCompletionTable from '@rd-web-markets/shared/dist/dashboards/components/SubsidiaryCompanyCompletionTable';
import SecureRamainingForecastQESubsidiaryCompany from '@rd-web-markets/shared/dist/dashboards/charts/SecureRemainingForecastQESubsidiaryCompany';
import RnDIntensitySubsidiary from '@rd-web-markets/shared/dist/dashboards/charts/RnDIntensitySubsidiary';
import ProjectAssessmentProgressBySubsidiaryCompany from '@rd-web-markets/shared/dist/dashboards/charts/ProjectAssessmentProgressBySubsidiaryCompany';
import ProjectAssessmentProgressByBusinessUnit from '@rd-web-markets/shared/dist/dashboards/charts/ProjectAssesmentProgressByBusinessUnit';
import { DDMMYYYStringToDate } from '@rd-web-markets/shared/dist/util/date';
export default function RegularRealtimeDashboard(_ref) {
  let {
      claimGroup
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const [selectedYears, setSelectedYears] = useState(claimGroup !== null && claimGroup !== void 0 && claimGroup.to_date ? [DDMMYYYStringToDate(claimGroup === null || claimGroup === void 0 ? void 0 : claimGroup.to_date).getFullYear()] : null);
  const [selectedBUDashboard, setSelectedBUDashboard] = useState(null);
  const [selectedSubsidiaryCompanyIds, setSelectedSubsidiaryCompanyIds] = useState([]);
  const [filteredBusinessUnits, setFilteredBusinessUnits] = useState([]);
  const [groupingMode, setGroupingMode] = useState('business_unit');
  const [showProjectAssessment, setShowProjectAssessment] = useState(false);
  const [isMultipleSelectionEnabled, setIsMultipleSelectionEnabled] = useState(false);
  const [isMultipleYearsEnabled, setIsMultipleYearsEnabled] = useState(false);
  const [isMultipleSubsidiaryCompaniesEnabled, setIsMultipleSubsidiaryCompaniesEnabled] = useState(false);
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [isAllSubsidiaryCompaniesSelected, setIsAllSubsidiaryCompaniesSelected] = useState(false);
  const user = useSelector(state => state.auth.user);
  const {
    company_id
  } = useParams();
  const {
    addRecentCompanyId
  } = useRecentVisits();
  const dashboardData = regularDashboardService.useFetchDashboardDataForYear(company_id, selectedYears);
  const isBU = groupingMode === 'business_unit';
  const isSub = groupingMode === 'subsidiary_company';
  const selectBusinessUnits = businessUnit => {
    setIsAllSelected(false);
    if (isMultipleSelectionEnabled) {
      const isSelected = selectedBUDashboard.findIndex(bu => bu.business_unit === businessUnit) > -1;
      if (isSelected) {
        if (selectedBUDashboard.length === 1) return;
        setSelectedBUDashboard(selectedBUDashboard.filter(bu => bu.business_unit !== businessUnit));
      } else {
        const buData = businessUnit === 'all' ? dashboardData.dashboard_without_business_unit : dashboardData.dashboard_by_business_unit.find(bu => bu.business_unit === businessUnit);
        setSelectedBUDashboard([...selectedBUDashboard, buData]);
      }
    } else {
      const buData = businessUnit === 'all' ? dashboardData.dashboard_without_business_unit : dashboardData.dashboard_by_business_unit.find(bu => bu.business_unit === businessUnit);
      setSelectedBUDashboard([buData]);
    }
  };
  const selectYear = year => {
    if (isMultipleYearsEnabled) {
      const isSelected = selectedYears.includes(year);
      if (isSelected) {
        if (selectedYears.length === 1) return;
        setSelectedYears(selectedYears.filter(y => y !== year));
      } else {
        setSelectedYears([...selectedYears, year]);
      }
    } else {
      setSelectedYears([year]);
    }
  };
  const selectSubsidiaryCompany = id => {
    setIsAllSubsidiaryCompaniesSelected(false);
    const isSelected = selectedSubsidiaryCompanyIds.includes(id);
    if (isSelected) {
      setSelectedSubsidiaryCompanyIds(selectedSubsidiaryCompanyIds.filter(sc => sc !== id));
    } else if (isMultipleSubsidiaryCompaniesEnabled) {
      setSelectedSubsidiaryCompanyIds([...selectedSubsidiaryCompanyIds, id]);
    } else {
      setSelectedSubsidiaryCompanyIds([id]);
    }
  };
  useEffect(() => {
    addRecentCompanyId(company_id);
  }, [company_id]);
  useEffect(() => {
    setFilteredBusinessUnits(selectedBUDashboard);
  }, [selectedBUDashboard]);
  useEffect(() => {
    if (dashboardData && isAllSelected) {
      setSelectedBUDashboard([...dashboardData.dashboard_by_business_unit, dashboardData.dashboard_without_business_unit]);
    }
  }, [isAllSelected, dashboardData]);
  useEffect(() => {
    if (isAllSubsidiaryCompaniesSelected && dashboardData) {
      setSelectedSubsidiaryCompanyIds([...dashboardData.subsidiary_companies.map(sc => sc.id), 0]);
    }
  }, [isAllSubsidiaryCompaniesSelected, dashboardData]);
  useEffect(() => {
    if (dashboardData && !selectedBUDashboard) {
      setIsAllSelected(true);

      // initialize all subsidiary companies
      const allSubsidiaryIds = [...dashboardData.subsidiary_companies.map(sc => sc.id), 0];
      setSelectedSubsidiaryCompanyIds(allSubsidiaryIds);
      setIsAllSubsidiaryCompaniesSelected(true);

      // default business-unit dashboard
      setSelectedBUDashboard([dashboardData.dashboard_without_business_unit]);
      // the client side is for a specific claim group, the admin side is not
      if (!claimGroup) {
        setSelectedYears([dashboardData.dashboard_years[0]]);
      }
    }
  }, [claimGroup, dashboardData, selectedBUDashboard]);
  const accountingPeriodPopover = /*#__PURE__*/React.createElement(Popover, {
    id: "popover-AP"
  }, /*#__PURE__*/React.createElement(CurrentClaimYear, {
    dashboardData: dashboardData,
    selectedYears: selectedYears,
    selectYear: selectYear,
    isMultipleYearsEnabled: isMultipleYearsEnabled,
    setIsMultipleYearsEnabled: setIsMultipleYearsEnabled,
    isBusinessUnitDashboardType: true
  }));
  const businessUnitPopover = /*#__PURE__*/React.createElement(Popover, {
    id: "popover-BU"
  }, /*#__PURE__*/React.createElement(BusinessUnitSelector, {
    dashboardData: dashboardData,
    isMultipleSelectionEnabled: isMultipleSelectionEnabled,
    setIsMultipleSelectionEnabled: setIsMultipleSelectionEnabled,
    selectedBUDashboard: selectedBUDashboard,
    selectBusinessUnits: selectBusinessUnits,
    isAllSelected: isAllSelected,
    setIsAllSelected: setIsAllSelected
  }));
  const subsidiaryCompanyPopover = /*#__PURE__*/React.createElement(Popover, {
    id: "popover-SC"
  }, /*#__PURE__*/React.createElement(SubsidiaryCompanySelector, {
    dashboardData: dashboardData,
    selectedSubsidiaryCompanyIds: selectedSubsidiaryCompanyIds,
    isMultipleSelectionEnabled: isMultipleSubsidiaryCompaniesEnabled,
    setIsMultipleSelectionEnabled: setIsMultipleSubsidiaryCompaniesEnabled,
    selectSubsidiaryCompany: selectSubsidiaryCompany,
    isAllSelected: isAllSubsidiaryCompaniesSelected,
    setIsAllSelected: setIsAllSubsidiaryCompaniesSelected
  }));
  if (!dashboardData || !selectedBUDashboard || !filteredBusinessUnits) return /*#__PURE__*/React.createElement(Loader, null);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BreadcrumbsPortal, null, /*#__PURE__*/React.createElement(Breadcrumb, null, /*#__PURE__*/React.createElement(Breadcrumb.Item, {
    linkAs: Link,
    linkProps: {
      to: "/".concat(user.account_type)
    }
  }, "Home"), /*#__PURE__*/React.createElement(Breadcrumb.Item, {
    linkAs: Link,
    linkProps: {
      to: "/".concat(user.account_type, "/dashboards")
    }
  }, "Dashboards"), /*#__PURE__*/React.createElement(Breadcrumb.Item, {
    active: true
  }, dashboardData.company_name))), /*#__PURE__*/React.createElement("div", {
    className: "ps-4 pe-4"
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    lg: 12
  }, /*#__PURE__*/React.createElement("div", {
    className: "dashboard-regular-header"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "ps-2 mt-2"
  }, dashboardData.company_name, " ", selectedYears === null || selectedYears === void 0 ? void 0 : selectedYears.sort((a, b) => a - b).join(', '), " R&D - Dashboard"), dashboardData.company_logo && /*#__PURE__*/React.createElement("img", {
    src: "data:image/png;base64,".concat(dashboardData.company_logo),
    alt: "".concat(dashboardData.company_name, " logo"),
    style: {
      height: 48,
      marginRight: 8
    }
  })))), /*#__PURE__*/React.createElement(Row, {
    className: "mb-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-wrap align-items-center"
  }, /*#__PURE__*/React.createElement(OverlayTrigger, {
    trigger: "click",
    placement: "bottom",
    overlay: accountingPeriodPopover
  }, /*#__PURE__*/React.createElement(Button, {
    icon: "tune",
    variant: "primary",
    className: "me-3 mb-2"
  }, "Accounting Period")), /*#__PURE__*/React.createElement(OverlayTrigger, {
    trigger: "click",
    placement: "bottom",
    overlay: businessUnitPopover
  }, /*#__PURE__*/React.createElement(Button, {
    icon: "tune",
    variant: "primary",
    className: "me-3 mb-2"
  }, "Business Unit")), /*#__PURE__*/React.createElement(OverlayTrigger, {
    trigger: "click",
    placement: "bottom",
    overlay: subsidiaryCompanyPopover
  }, /*#__PURE__*/React.createElement(Button, {
    icon: "tune",
    variant: "primary",
    className: "me-3 mb-2"
  }, "Subsidiary Company")), /*#__PURE__*/React.createElement(Form.Check, {
    inline: true,
    type: "switch",
    id: "grouping-switch",
    label: isBU ? 'Grouped by Business Unit' : 'Grouped by Subsidiary Company',
    checked: isSub,
    onChange: e => setGroupingMode(e.target.checked ? 'subsidiary_company' : 'business_unit'),
    className: "ms-3 mb-2"
  }))), /*#__PURE__*/React.createElement(Row, props, /*#__PURE__*/React.createElement(Col, {
    lg: 12
  }, /*#__PURE__*/React.createElement(Row, {
    className: "pb-4"
  }, /*#__PURE__*/React.createElement(Col, {
    lg: 4
  }, isBU && /*#__PURE__*/React.createElement(BusinessUnitCompletionTable, {
    filteredBusinessUnits: filteredBusinessUnits,
    selectedYears: selectedYears,
    companyId: company_id,
    selectedSubsidiaryCompanyIds: selectedSubsidiaryCompanyIds
  }), isSub && /*#__PURE__*/React.createElement(SubsidiaryCompanyCompletionTable, {
    companyId: company_id,
    selectedSubsidiaryCompanyIds: selectedSubsidiaryCompanyIds,
    filteredBusinessUnits: filteredBusinessUnits,
    selectedYears: selectedYears
  })), /*#__PURE__*/React.createElement(Col, {
    lg: 3
  }, /*#__PURE__*/React.createElement(BusinessProjectStatePieChart, {
    filteredBusinessUnits: filteredBusinessUnits,
    selectedBUDashboard: selectedBUDashboard,
    selectedYears: selectedYears,
    companyId: company_id,
    dashboard_raw_projects: dashboardData.dashboard_raw_projects,
    selectedSubsidiaryCompanyIds: selectedSubsidiaryCompanyIds,
    height: '360px'
  })), /*#__PURE__*/React.createElement(Col, {
    lg: 5
  }, /*#__PURE__*/React.createElement(TotalQEAndIntensity, {
    companyId: company_id,
    selectedSubsidiaryCompanyIds: selectedSubsidiaryCompanyIds,
    filteredBusinessUnits: filteredBusinessUnits,
    selectedYears: selectedYears
  }))))), /*#__PURE__*/React.createElement(Row, null, isBU && /*#__PURE__*/React.createElement(Col, {
    lg: 6
  }, /*#__PURE__*/React.createElement(SecureRamainingForecastQE, {
    filteredBusinessUnits: filteredBusinessUnits,
    selectedYears: selectedYears,
    selectedSubsidiaryCompanyIds: selectedSubsidiaryCompanyIds,
    companyId: company_id
  })), isSub && /*#__PURE__*/React.createElement(Col, {
    lg: 6
  }, /*#__PURE__*/React.createElement(SecureRamainingForecastQESubsidiaryCompany, {
    companyId: company_id,
    selectedSubsidiaryCompanyIds: selectedSubsidiaryCompanyIds,
    filteredBusinessUnits: filteredBusinessUnits,
    selectedYears: selectedYears
  })), isBU && /*#__PURE__*/React.createElement(Col, {
    lg: 6,
    className: "position-relative"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "link",
    onClick: () => setShowProjectAssessment(prev => !prev),
    className: "position-absolute top-0 end-0 me-3 mt-2",
    style: {
      fontSize: '24px',
      lineHeight: 1
    }
  }, showProjectAssessment ? '→' : '←'), showProjectAssessment ? /*#__PURE__*/React.createElement(ProjectAssessmentProgressByBusinessUnit, {
    companyId: company_id,
    selectedYears: selectedYears,
    filteredBusinessUnits: filteredBusinessUnits,
    selectedSubsidiaryCompanyIds: selectedSubsidiaryCompanyIds
  }) : /*#__PURE__*/React.createElement(RnDIntensity, {
    filteredBusinessUnits: filteredBusinessUnits,
    selectedYears: selectedYears,
    companyId: company_id,
    selectedSubsidiaryCompanyIds: selectedSubsidiaryCompanyIds
  })), isSub && /*#__PURE__*/React.createElement(Col, {
    lg: 6,
    className: "position-relative"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "link",
    onClick: () => setShowProjectAssessment(prev => !prev),
    className: "position-absolute top-0 end-0 me-3 mt-2",
    style: {
      fontSize: '24px',
      lineHeight: 1
    }
  }, showProjectAssessment ? '→' : '←'), showProjectAssessment ? /*#__PURE__*/React.createElement(ProjectAssessmentProgressBySubsidiaryCompany, {
    companyId: company_id,
    filteredBusinessUnits: filteredBusinessUnits,
    selectedYears: selectedYears,
    selectedSubsidiaryCompanyIds: selectedSubsidiaryCompanyIds
  }) : /*#__PURE__*/React.createElement(RnDIntensitySubsidiary, {
    companyId: company_id,
    filteredBusinessUnits: filteredBusinessUnits,
    selectedSubsidiaryCompanyIds: selectedSubsidiaryCompanyIds,
    selectedYears: selectedYears
  })))));
}